import React, { Component } from 'react';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import RadioButton from 'components/shared/radio-button/RadioButton';
import './DeclineForm.css';
import { connect } from 'react-redux';
import Input from 'components/shared/input/Input';
import Dropdown from 'components/shared/dropdown/Dropdown';
import TextArea from 'components/shared/input/TextArea';

export const REASON_OPTIONS = {
  1: 'Pricing',
  2: 'Schedule',
  3: 'Using Preferred Contractor',
};

class DeclineFormClass extends Component {
  renderDropDown = (props) => {
    return (
      <Dropdown
        valid={!props.meta.error || !props.meta.submitFailed}
        value={props.input.value}
        onChange={(option) => props.input.onChange(option.value)}
        {...props}
      />
    );
  };

  renderInput = (props) => {
    return (
      <Input
        valid={!props.meta.error || !props.meta.submitFailed}
        value={props.input.value}
        onChange={(value) => props.input.onChange(value)}
        {...props}
      />
    );
  };

  renderRadioButton = (props) => {
    return (
      <RadioButton
        value={props.input.value}
        onChange={(value) => props.input.onChange(value)}
        {...props}
      />
    );
  };

  renderTextArea = (props) => {
    return (
      <TextArea
        value={props.input.value}
        onChange={(value) => props.input.onChange(value)}
        {...props}
      />
    );
  };

  render() {
    return (
      <div className="decline-form">
        <form onSubmit={this.props.handleSubmit}>
          <div className="h2">Are you sure?</div>
          <div className="question-container">
            <Field
              component={this.renderRadioButton}
              options={[
                {
                  value: 'yes',
                  label: 'Yes',
                },
                {
                  value: 'no',
                  label: 'No',
                },
              ]}
              name="sure"
            />
          </div>

          {this.props.isSure && (
            <div className="reason-container">
              <Field
                component={this.renderInput}
                name="password"
                placeholder="Enter the password"
                type="password"
              />
              <Field
                component={this.renderDropDown}
                name="reason"
                options={Object.keys(REASON_OPTIONS).map((key) => ({
                  value: key,
                  label: REASON_OPTIONS[key],
                }))}
                placeholder="Select the reason"
              />
              <Field
                component={this.renderTextArea}
                name="additionalInfo"
                placeholder="Enter additional info (optional)"
              />
            </div>
          )}
          <div className="continue-container">
            <input
              className="btn button button-orange"
              type="submit"
              value="Continue"
            />
          </div>
        </form>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};
  if (!values.password) {
    errors.password = 'Required';
  }
  if (!values.reason) {
    errors.reason = 'Required';
  }
  return errors;
}

let DeclineForm = reduxForm({
  form: 'DeclineForm',
  validate,
})(DeclineFormClass);

const selector = formValueSelector('DeclineForm');
DeclineForm = connect((state) => {
  const isSure = selector(state, 'sure') === 'yes';
  return {
    isSure,
  };
})(DeclineForm);

export default DeclineForm;



// WEBPACK FOOTER //
// ./src/components/shared/modal/DeclineForm.js